/**
 * Leprendo Filters Module
 * URL-driven faceted filtering + sort for collection pages.
 * Uses History API — no full page reload.
 */

(function () {
  'use strict';

  const Filters = {
    form: null,
    gridEl: null,
    countEl: null,
    loading: false,

    init() {
      this.form = document.querySelector('[data-filter-form]');
      this.gridEl = document.querySelector('[data-product-grid]');
      this.countEl = document.querySelector('[data-product-count]');
      if (!this.form || !this.gridEl) return;

      // Filter/sort changes
      this.form.querySelectorAll('input, select').forEach(el => {
        el.addEventListener('change', () => this.applyFilters());
      });

      // Sort dropdown (outside filter form)
      const sortEl = document.querySelector('[data-sort-select]');
      if (sortEl) sortEl.addEventListener('change', () => this.applyFilters());

      // Active filter pill removals
      document.addEventListener('click', e => {
        const pill = e.target.closest('[data-remove-filter]');
        if (!pill) return;
        const param = pill.dataset.removeFilter;
        const url = new URL(window.location.href);
        url.searchParams.delete(param);
        window.history.pushState({}, '', url.toString());
        this.fetchAndRender(url.toString());
        this.syncFormToUrl(url);
      });

      // Clear all
      const clearBtn = document.querySelector('[data-clear-filters]');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          const url = new URL(window.location.href);
          // Remove all filter params, keep sort
          const sort = url.searchParams.get('sort_by');
          url.search = '';
          if (sort) url.searchParams.set('sort_by', sort);
          window.history.pushState({}, '', url.toString());
          this.fetchAndRender(url.toString());
          this.form.reset();
        });
      }

      // Mobile filter drawer
      const toggleBtn = document.querySelector('[data-filter-toggle]');
      const filterPanel = document.querySelector('[data-filter-panel]');
      if (toggleBtn && filterPanel) {
        toggleBtn.addEventListener('click', () => {
          filterPanel.classList.toggle('open');
          toggleBtn.setAttribute('aria-expanded', filterPanel.classList.contains('open'));
        });
      }

      // Popstate (browser back/forward)
      window.addEventListener('popstate', () => {
        this.fetchAndRender(window.location.href);
        this.syncFormToUrl(new URL(window.location.href));
      });
    },

    applyFilters() {
      const url = this.buildUrl();
      window.history.pushState({}, '', url.toString());
      this.fetchAndRender(url.toString());
    },

    buildUrl() {
      const url = new URL(window.location.href);
      // Clear existing filter params
      const keysToRemove = [];
      url.searchParams.forEach((_, key) => {
        if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
          keysToRemove.push(key);
        }
      });
      keysToRemove.forEach(k => url.searchParams.delete(k));

      // Add active filters
      if (this.form) {
        new FormData(this.form).forEach((value, key) => {
          if (value) url.searchParams.append(key, value);
        });
      }

      // Add sort
      const sortEl = document.querySelector('[data-sort-select]');
      if (sortEl?.value) url.searchParams.set('sort_by', sortEl.value);

      // Reset to page 1
      url.searchParams.delete('page');
      return url;
    },

    async fetchAndRender(urlStr) {
      if (this.loading) return;
      this.loading = true;
      this.gridEl.style.opacity = '0.5';
      this.gridEl.style.pointerEvents = 'none';

      try {
        const res = await fetch(`${urlStr}${urlStr.includes('?') ? '&' : '?'}sections=product-grid`);
        const data = await res.json();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['product-grid'] || '', 'text/html');
        const newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid) this.gridEl.innerHTML = newGrid.innerHTML;

        const countEl = doc.querySelector('[data-product-count]');
        if (countEl && this.countEl) this.countEl.textContent = countEl.textContent;

        this.renderActivePills(new URL(urlStr));
        this.gridEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (err) {
        console.error('Filter fetch failed:', err);
      } finally {
        this.loading = false;
        this.gridEl.style.opacity = '';
        this.gridEl.style.pointerEvents = '';
      }
    },

    renderActivePills(url) {
      const container = document.querySelector('[data-active-filters]');
      if (!container) return;
      container.innerHTML = '';
      url.searchParams.forEach((value, key) => {
        if (!key.startsWith('filter.')) return;
        const pill = document.createElement('span');
        pill.className = 'active-filter-pill';
        pill.innerHTML = `${value} <button data-remove-filter="${key}" aria-label="Remove filter">&times;</button>`;
        container.appendChild(pill);
      });
    },

    syncFormToUrl(url) {
      if (!this.form) return;
      this.form.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        cb.checked = url.searchParams.getAll(cb.name).includes(cb.value);
      });
      const sortEl = document.querySelector('[data-sort-select]');
      if (sortEl) sortEl.value = url.searchParams.get('sort_by') || '';
    }
  };

  document.addEventListener('DOMContentLoaded', () => Filters.init());
})();
